import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_09.jpg'
import { ISponsorshipsResponse } from '../../../models/Sponsorship'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Sponsorships } from '../../templates/Sponsorships'

const SponsorshipPage = () => {
  const i18n = useRecoilValue(translate).sponsorship
  const breadcrumbs = [
    {
      link: routes.sponsorship,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<ISponsorshipsResponse>(URI.getSponsorshipsUri(lang))

  return (
    <>
      <ImageSection id={'sponsorship'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data && <Sponsorships data={data.data} />}
      </PageWrapper>
    </>
  )
}

export default SponsorshipPage
